/**
 * Utility functions for navigation section detection
 */

export const NAVIGATION_PATHS = {
  SALE: ['/sale'],
  STORES: ['/magic-stores'],
  PLAYING_CARDS: [
    '/playing-cards',
    '/newest-playing-cards',
    '/vanishing-inc-decks',
    '/playing-card-storage',
    '/cardistry-decks',
    '/card-clips',
  ],
  MAGIC: [
    '/',
    '/magic-',
    '/props',
    '/mentalism',
    '/masterclass',
    '/exclusives',
    '/blog/',
  ],
} as const

/**
 * Determines which navigation section is active based on pathname
 */
export const getActiveSection = (
  pathname: string | null
): 'magic' | 'playing-cards' | 'stores' | 'sale' | null => {
  if (!pathname) return null

  // Check stores first since /magic-stores starts with /magic-
  if (NAVIGATION_PATHS.STORES.some(path => pathname.startsWith(path))) {
    return 'stores'
  }

  if (NAVIGATION_PATHS.SALE.some(path => pathname.startsWith(path))) {
    return 'sale'
  }

  if (NAVIGATION_PATHS.PLAYING_CARDS.some(path => pathname.startsWith(path))) {
    return 'playing-cards'
  }

  // Check magic section (including home page)
  if (
    pathname === '/' ||
    NAVIGATION_PATHS.MAGIC.some(path => path !== '/' && pathname.startsWith(path))
  ) {
    return 'magic'
  }

  // Default to magic for unknown routes
  return 'magic'
}
